import { useMutation } from '@tanstack/react-query';

import { authApi } from '../../apis/accounting-api/auth/auth-api';

export const useLogin = () => {
  return useMutation({
    mutationFn: ({
      username,
      password,
    }: {
      username: string;
      password: string;
    }) => authApi.login(username, password),
  });
};
